import React from 'react';
import type { Goal } from '../../../data/mockData';
interface GoalProgressProps {
  goals: Goal[];
}
export function GoalProgressCards({
  goals
}: GoalProgressProps) {
  return <div className="mt-3 space-y-2" data-id="element-99">
      {goals.slice(0, 3).map(goal => {
      const pct = Math.round(goal.currentAmount / goal.targetAmount * 100);
      const remaining = goal.targetAmount - goal.currentAmount;
      return <div key={goal.id} className="bg-gray-50 dark:bg-dark-hover rounded-xl p-3" data-id="element-100">
            <div className="flex items-center justify-between mb-2" data-id="element-101">
              <div className="flex items-center gap-2" data-id="element-102">
                <span className="text-lg" data-id="element-103">{goal.emoji}</span>
                <div data-id="element-104">
                  <p className="text-xs font-semibold text-gray-800 dark:text-gray-200" data-id="element-105">
                    {goal.name}
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-106">
                    ${goal.currentAmount.toLocaleString()} / $
                    {goal.targetAmount.toLocaleString()}
                  </p>
                </div>
              </div>
              <span className="text-sm font-bold" style={{
            color: goal.color
          }} data-id="element-107">
                {pct}%
              </span>
            </div>
            <div className="h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden" data-id="element-108">
              <div className="h-full rounded-full transition-all duration-700" style={{
            width: `${pct}%`,
            backgroundColor: goal.color
          }} data-id="element-109" />
            </div>
            <p className="text-xs text-gray-500 mt-1" data-id="element-110">
              ${remaining.toLocaleString()} remaining · Due{' '}
              {new Date(goal.deadline).toLocaleDateString('en-US', {
            month: 'short',
            year: 'numeric'
          })}
            </p>
          </div>;
    })}
    </div>;
}